// extracted by mini-css-extract-plugin
export default {"divider":"divider__QGNff1g3UmEk","DropdownMenu":"DropdownMenu__VbgIPXIO7xXP"};